import { useTranslation } from 'react-i18next';
import type { IconName } from '../../icons/types';
import { isIconName } from '../../icons/types';
import { formatFileSize, getFileIconType } from '../UploadArea/uploadAreaUtils';
import type { UploadFileItemProps } from './UploadFileItem';

type UseUploadFileItemResult = Readonly<{
  deleteFileLabel: string;
  fileIcon: IconName;
  fileSize: string;
  uploadingLabel: string;
}>;

function useUploadFileItem({ file }: Pick<UploadFileItemProps, 'file'>): UseUploadFileItemResult {
  const { t } = useTranslation(['actions', 'common']);
  const icon = getFileIconType(file.name);
  const uploadingLabel = t('common:Uploading file');

  return {
    deleteFileLabel: t('actions:Delete file', { name: file.name }),
    fileIcon: isIconName(icon) ? icon : 'file-document',
    fileSize: formatFileSize(file.size),
    uploadingLabel,
  };
}

export default useUploadFileItem;
